export default __webpack_public_path__ + "static/media/results.a4f67f50.png";